module.exports = __webpack_public_path__ + "img/mentoring-lg.d30764e2.jpg";